var _path, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 0.375H2.0625C1.51549 0.375 0.990886 0.592299 0.604092 0.979092C0.217298 1.36589 0 1.89049 0 2.4375L0 17.5625C0 18.1095 0.217298 18.6341 0.604092 19.0209C0.990886 19.4077 1.51549 19.625 2.0625 19.625H7.95996V13.0804H5.25293V10H7.95996V7.65219C7.95996 4.98168 9.54981 3.50656 11.9848 3.50656C13.151 3.50656 14.3705 3.71453 14.3705 3.71453V6.33563H13.0268C11.703 6.33563 11.29 7.15719 11.29 7.9998V10H14.2454L13.7728 13.0804H11.29V19.625H17.1875C17.7345 19.625 18.2591 19.4077 18.6459 19.0209C19.0327 18.6341 19.25 18.1095 19.25 17.5625V2.4375C19.25 1.89049 19.0327 1.36589 18.6459 0.979092C18.2591 0.592299 17.7345 0.375 17.1875 0.375V0.375Z",
    fill: "url(#paint0_linear_561_723)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_561_723",
    x1: 19.25,
    y1: 0.375,
    x2: 0,
    y2: 0.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8468BF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.eb6d110e5b6eb4c24f463657ff55c293.svg";
export { ForwardRef as ReactComponent };